"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var app_1 = require("spry-react/App/app");
var positioning_1 = require("spry-react/utils/positioning");
var react_focus_lock_1 = require("react-focus-lock");
var ContextMenuContainer = /** @class */ (function (_super) {
    __extends(ContextMenuContainer, _super);
    function ContextMenuContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.onWindowResize = function (event) {
            if (app_1.isRelativePosition(_this.props.contextMenu.position)) {
                var position = _this.positionMenu();
                if (position)
                    _this.setState({ top: position.top, left: position.left });
            }
            else {
                _this.props.closeContextMenu();
            }
        };
        _this.getRelativePositionElement = function (contextMenu) {
            if (!app_1.isRelativePosition(contextMenu.position))
                return null;
            return document.getElementById(contextMenu.position.relativeElementId);
        };
        _this.state = { top: '0', left: '0' };
        return _this;
    }
    ContextMenuContainer.prototype.render = function () {
        var _this = this;
        var contextMenu = this.props.contextMenu;
        var renderedContextMenu = contextMenu.render(contextMenu.data, this.props.closeContextMenu);
        var style = __assign(__assign({}, this.props.currentStyle), { position: "absolute", display: 'block', top: this.state.top, left: this.state.left });
        var relativePositionElement = this.getRelativePositionElement(contextMenu);
        return React.createElement("nav", { className: "drop-menu", style: style, ref: function (node) { _this.navElement = node; _this.props.childRef(node); }, role: "menu" },
            React.createElement(react_focus_lock_1.default, { shards: relativePositionElement ? [relativePositionElement] : [], returnFocus: !!relativePositionElement }, renderedContextMenu));
    };
    ContextMenuContainer.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.onWindowResize);
        var position = this.positionMenu();
        if (position)
            this.setState({ top: position.top, left: position.left });
    };
    ContextMenuContainer.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.onWindowResize);
    };
    ContextMenuContainer.prototype.positionMenu = function () {
        if (!this.navElement)
            return;
        var position = this.props.contextMenu.position;
        if (app_1.isRelativePosition(position)) {
            var relativeElement = document.getElementById(position.relativeElementId);
            if (!relativeElement)
                return;
            var relativePosition = positioning_1.getRelativePosition(this.navElement, relativeElement, position.horizontalAlignment || positioning_1.HorizontalAlignment.AlignLeftSides, position.verticalAlignment || positioning_1.VerticalAlignment.Below, false);
            return {
                top: relativePosition.top + "px",
                left: relativePosition.left + "px"
            };
        }
        else {
            var adjustedPosition = positioning_1.getAbsolutePostion(this.navElement, position.x, position.y);
            return { top: adjustedPosition.y + "px", left: adjustedPosition.x + "px" };
        }
    };
    return ContextMenuContainer;
}(React.Component));
exports.ContextMenuContainer = ContextMenuContainer;
